import PasswordRequestContext from 'modules/passwordRequest/contexts/PasswordRequestContext'
import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { OAuthPasswordReturn } from '../contexts/PasswordRequestContext'

const PasswordRequestProvider: FC = ({ children }) => {
  const email = useState<string>()
  const oauthReturn = useState<OAuthPasswordReturn>()
  const [, setOAuthReturn] = oauthReturn
  const { pathname } = useLocation()

  useEffect(() => {
    if (pathname !== '/register-new-password' && pathname !== '/verification-code')
      setOAuthReturn(undefined)
  }, [pathname, setOAuthReturn])
  const password = useState<string>()
  const errorRequestPassword = useState<string>()

  return (
    <PasswordRequestContext.Provider value={{ email, password, errorRequestPassword, oauthReturn }}>
      {children}
    </PasswordRequestContext.Provider>
  )
}

export default PasswordRequestProvider
